export const cryptoSecret = 'MN^Gi73r*&gbKFL3qqf3odUs9ufOR#1@R#r'
